module.exports = __webpack_public_path__ + "static/media/notes.1088d58e.svg";